var paragraph_default = {
  "fontElementMap": "_9yhBH",
  "elementSpacing": "d9zr0",
  "text": "_8QQRx d9zr0",
  "child": "lEnMT"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
